import React, { useState } from "react";

export default function Notification({ notification }) {
	const dict = {
		0: "is-danger",
		1: "is-warning",
		2: "is-info",
		3: "is-success",
	};

	const [isVisible, setIsVisible] = useState(true);

	if (!notification || !isVisible) return null;

	return (
		<div className={`notification  ${dict[notification.type]}`}>
			<button className="delete" onClick={() => setIsVisible(false)}></button>
			<p className="has-text-weight-semibold">{notification.message}</p>
		</div>
	);
}
